<template>
  <card-list
    title="Transaksi Berhasil"
    data-url="/api/v1/po/intransit"
    data-size="10"
    previewUrl="/po/preview/:id:?preview=true&rollback=/po/process&printurl=/print/po/faktur"
    :dataHeaders="tHeaders"
  />
</template>
<script>
import CardList from "../../components/CardList";
export default {
  components: {
    CardList
  },
  data() {
    return {
      tHeaders: [
        {supplier_name: "Suplier", align: 'left', type: 'text'},
        {inv_po: "No PO", align: 'left', type: 'text'},
        {faktur: "Faktur", align: 'left', type: 'text'},
        {eta: "ETA", align: 'left', type: 'text'},
        {etd: "ETD", align: 'left', type: 'text'},
        {delivery_route: "Delivery Route", align: 'left', type: 'text'},
        {created_at: "Created At", align: 'left', type: 'text'},
        {total: "Total", align: 'right', type: 'number'},
      ]
    }
  }
};
</script>